var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,5c-3.01977,0 -5.5,2.48023 -5.5,5.5v22c0,3.01977 2.48023,5.5 5.5,5.5h16c3.01977,0 5.5,-2.48023 5.5,-5.5v-22c0,-3.01977 -2.48023,-5.5 -5.5,-5.5zM18.5,8h16c1.39823,0 2.5,1.10177 2.5,2.5v22c0,1.39823 -1.10177,2.5 -2.5,2.5h-16c-1.39823,0 -2.5,-1.10177 -2.5,-2.5v-22c0,-1.39823 1.10177,-2.5 2.5,-2.5zM11,10l-1.21875,0.8125c-1.113,0.742 -1.78125,1.99113 -1.78125,3.32813v19.35938c0,5.247 4.253,9.5 9.5,9.5h13.35938c1.338,0 2.58713,-0.66825 3.32813,-1.78125l0.8125,-1.21875h-17.5c-3.59,0 -6.5,-2.91 -6.5,-6.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e70b565057bdc7be2ccaf56c261cd752.svg";
export { ForwardRef as ReactComponent };